(function () {
  const instances = new Map();
  const MOBILE_MQ = '(max-width: 989px)';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isMobile() {
    return window.matchMedia(MOBILE_MQ).matches;
  }

  function destroy(section) {
    const instance = instances.get(section);
    if (!instance) return;

    if (instance.mq && instance.onMqChange) {
      if (instance.mq.removeEventListener) {
        instance.mq.removeEventListener('change', instance.onMqChange);
      } else if (instance.mq.removeListener) {
        instance.mq.removeListener(instance.onMqChange);
      }
    }

    if (instance.swiper) {
      instance.swiper.destroy(true, true);
    }

    instances.delete(section);
  }

  function createSwiper(container) {
    if (!window.XBLOOM3 || !window.XBLOOM3.Swiper) return null;
    if (!container) return null;
    if (container.swiper) return container.swiper;

    const speed = parseInt(container.getAttribute('data-speed'), 10) || 6000;

    return new window.XBLOOM3.Swiper(container, {
      slidesPerView: 'auto',
      loop: true,
      speed: speed,
      allowTouchMove: false,
      watchSlidesProgress: true,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
    });
  }

  function syncSwiper(section) {
    const instance = instances.get(section);
    if (!instance) return;

    const shouldRun = isMobile() && !prefersReducedMotion();

    if (shouldRun && !instance.swiper) {
      instance.swiper = createSwiper(instance.container);
    } else if (!shouldRun && instance.swiper) {
      instance.swiper.destroy(true, true);
      instance.swiper = null;
    }
  }

  function init(section) {
    if (!section || instances.has(section)) return;

    const container = section.querySelector('[data-swiper-container]');
    if (!container) return;

    const mq = window.matchMedia(MOBILE_MQ);
    const instance = {
      container: container,
      swiper: null,
      mq: mq,
      onMqChange: null,
    };

    instances.set(section, instance);

    instance.onMqChange = function () {
      syncSwiper(section);
    };

    if (mq.addEventListener) {
      mq.addEventListener('change', instance.onMqChange);
    } else if (mq.addListener) {
      mq.addListener(instance.onMqChange);
    }

    syncSwiper(section);
  }

  function initAll(context) {
    const root = context || document;

    if (root.classList && root.classList.contains('stats-marquee')) {
      init(root);
    }

    const sections = root.querySelectorAll ? root.querySelectorAll('.stats-marquee') : [];
    sections.forEach(init);
  }

  function waitForSwiper(attempt) {
    if (window.XBLOOM3 && window.XBLOOM3.Swiper) {
      initAll(document);
      return;
    }

    if (attempt > 20) return;
    setTimeout(function () {
      waitForSwiper(attempt + 1);
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      waitForSwiper(0);
    });
  } else {
    waitForSwiper(0);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    const root = event.target;

    if (root.classList && root.classList.contains('stats-marquee')) {
      destroy(root);
    }

    const sections = root.querySelectorAll ? root.querySelectorAll('.stats-marquee') : [];
    sections.forEach(destroy);
  });
})();
